import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { DependentModule } from "../shared/dependent.module";
import { ShelfComponent } from './shelf.component';
import { MycontentComponent } from './mycontent/mycontent.component';
import { NewFolderDialog,deleteFolderPopup,createEleComponent } from './mycontent/mycontent.component';
import { ShelfPouchDb } from './shelf.pouchdb.service';
import { LoginComponent,enterRedeem } from './popups/login/login.component';
import { BooksFilterComponent } from './popups/booksFilter/booksFilter.component';
import { AllComponent,createFolderBooks } from './all/all.component';
import { ShelfAppendDirective } from './directives/shelfAppend.directive';
import { BookshelfComponent,createFolderBookshelf } from './bookshelf/bookshelf.component';
import { FilterArrayPipe } from './filter.pipe';
import { BookdetailsComponent } from './popups/bookdetails/bookdetails.component';
import { GoogledriveComponent } from './googleDrive/googledrive/googledrive.component';
import {CreatedBookInfoComponent} from './popups/createdBookInfo/createdBookInfo.component'
import { ClouddataComponent,Uploadfile,NewFolderDialogGoogle  } from './Clouddata/Clouddata.component';
import { GoogledrivefilterdataComponent } from './popups/Googledrivefilterdata/Googledrivefilterdata.component';
import { Ng2OrderModule } from 'ng2-order-pipe';
import { OrderbyPipe } from './Orderby.pipe';
import { GoogledetailsComponent, message } from './popups/Googledetails/Googledetails.component';
import { sharefile } from './popups/Googledetails/Googledetails.component';
import { ExamComponent } from '../exam/exam.component';

import { ActivityComponent } from './activity/activity.component';
import { ResourcesComponent } from './resources/resources.component';
import { ConnectComponent } from './connect/connect.component';
import { InboxComponent } from './inbox/inbox.component';
import { InboxDetailsComponent } from './inboxDetails/inboxDetails.component';
import { InboxPouchService } from './inbox/inbox.pouchdb.service';
import { Ng4FilesModule } from './Clouddata/ng4-files'
import { ConformationDialogComponent } from './popups/ConformationDialog/ConformationDialog.component';
import { ExportviewComponent } from '../bookShared/popups/export/export.component';
import { ExportService } from '../bookShared/popups/export/exoprt.service';
import { DropboxComponent } from './dropbox/dropbox.component';
@NgModule({
  imports: [
    CommonModule,
    DependentModule,
    Ng4FilesModule,
  
    Ng2OrderModule
  ],
  declarations: [
    FilterArrayPipe,
    ShelfComponent,
    MycontentComponent,
    NewFolderDialog,
    createFolderBooks,
    NewFolderDialogGoogle,
    deleteFolderPopup,
    createEleComponent,
    AllComponent,
    ShelfAppendDirective,
    BookshelfComponent,
    createFolderBookshelf,
    LoginComponent,
    enterRedeem,
    BooksFilterComponent,
    BookdetailsComponent,
    CreatedBookInfoComponent,sharefile,message,
    GoogledriveComponent,
    GoogledetailsComponent,
    ClouddataComponent,
    GoogledrivefilterdataComponent,
    OrderbyPipe,Uploadfile,
    ActivityComponent,
    ResourcesComponent,
    ConnectComponent,
    ExamComponent,
    ConformationDialogComponent,
     InboxComponent,
    InboxDetailsComponent,
    ExportviewComponent,
    DropboxComponent
],
  providers: [ShelfPouchDb, InboxPouchService, ExportService],
  entryComponents: [ShelfComponent,
    AllComponent,
    BookshelfComponent,
    createFolderBookshelf,
 GoogledrivefilterdataComponent,
    NewFolderDialog,NewFolderDialogGoogle,
    createFolderBooks,
    deleteFolderPopup,
    createEleComponent,
    LoginComponent, Uploadfile,
    BooksFilterComponent, CreatedBookInfoComponent, sharefile, message,
    BookdetailsComponent, GoogledetailsComponent,
    GoogledriveComponent, enterRedeem, ExamComponent,ConformationDialogComponent,InboxDetailsComponent, ExportviewComponent,DropboxComponent
  ],
  exports: []
})
export class ShelfModule { }



// WEBPACK FOOTER //
// ./src/app/shelf/shelf.module.ts